import * as axios from 'axios';
import URL from 'url-parse';
import {funcAppUrl} from '../provider/authConfig';

export function getBaseUrl() {
  const uri = new URL();
  const { protocol, hostname, port } = uri;

  if (hostname === 'localhost' && port === '3000') {
    return `${protocol}//${hostname}:3001/ORBService`;
  } 
  return funcAppUrl + '/api/ORBService';
}

export const service = axios.create({
  baseURL: getBaseUrl(),
  withCredentials: false
});

export default service;



// WEBPACK FOOTER //
// ./src/utility/service.js